/**
 * Generated from SelectLocationLayout.fla
 */
export function SelectLocationLayout(this: ISelectLocationLayout) {
	const main = this.main;
	SelectLocationLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function SelectLocationLayout_main(this: ISelectLocationLayout_main) {
	const globe = this.globe;
	SelectLocationLayout_globe.call(this.globe);
	globe.x = -0.5;
	globe.y = 1199;
	if (globe.onLayout) globe.onLayout();
	const buttonNext = this.buttonNext;
	SelectLocationLayout_buttonNext.call(this.buttonNext);
	buttonNext.x = 889.5;
	buttonNext.y = -30.5;
	buttonNext.width = 215.00;
	buttonNext.height = 215.00;
	if (buttonNext.onLayout) buttonNext.onLayout();
	const buttonBack = this.buttonBack;
	SelectLocationLayout_buttonBack.call(this.buttonBack);
	buttonBack.x = -878.5;
	buttonBack.y = -30.5;
	buttonBack.width = 215.00;
	buttonBack.height = 215.00;
	if (buttonBack.onLayout) buttonBack.onLayout();
	const frontClouds = this.frontClouds;
	SelectLocationLayout_frontClouds.call(this.frontClouds);
	frontClouds.x = -86.65;
	frontClouds.y = 768;
	frontClouds.width = 2586.00;
	frontClouds.height = 243.00;
	if (frontClouds.onLayout) frontClouds.onLayout();
	const luna = this.luna;
	SelectLocationLayout_luna.call(this.luna);
	luna.x = 649.2;
	luna.y = 847.15;
	luna.width = 646.00;
	luna.height = 662.00;
	if (luna.onLayout) luna.onLayout();
	const buttonFreePlay = this.buttonFreePlay;
	SelectLocationLayout_buttonFreePlay.call(this.buttonFreePlay);
	buttonFreePlay.x = -861.2;
	buttonFreePlay.y = 615;
	buttonFreePlay.width = 303.00;
	buttonFreePlay.height = 306.00;
	if (buttonFreePlay.onLayout) buttonFreePlay.onLayout();
	const envelope = this.envelope;
	SelectLocationLayout_envelope.call(this.envelope);
	envelope.x = 0;
	envelope.y = -411.5;
	if (envelope.onLayout) envelope.onLayout();
	const envelopeSelected = this.envelopeSelected;
	SelectLocationLayout_envelopeSelected.call(this.envelopeSelected);
	envelopeSelected.x = 0;
	envelopeSelected.y = -33.7;
	if (envelopeSelected.scale) envelopeSelected.scale.x = 1.200;
	if (envelopeSelected.scale) envelopeSelected.scale.y = 1.200;
	if (envelopeSelected.onLayout) envelopeSelected.onLayout();
	return this;
}
function SelectLocationLayout_globe(this: ISelectLocationLayout_globe) {
	const cityBack = this.cityBack;
	if (!cityBack[0] && cityBack.elementFactory) {
		cityBack[0] = cityBack.elementFactory(0,undefined);
	}
	if (cityBack[0]) {
		SelectLocationLayout_cityBackRio.call(cityBack[0] as ISelectLocationLayout_cityBackRio);
		cityBack[0].x = 0;
		cityBack[0].y = 0;
		if (cityBack[0].onLayout) cityBack[0].onLayout();
	}
	if (!cityBack[1] && cityBack.elementFactory) {
		cityBack[1] = cityBack.elementFactory(1,undefined);
	}
	if (cityBack[1]) {
		SelectLocationLayout_cityBackNairobi.call(cityBack[1] as ISelectLocationLayout_cityBackNairobi);
		cityBack[1].x = 0;
		cityBack[1].y = 0;
		if (cityBack[1].onLayout) cityBack[1].onLayout();
	}
	if (!cityBack[2] && cityBack.elementFactory) {
		cityBack[2] = cityBack.elementFactory(2,undefined);
	}
	if (cityBack[2]) {
		SelectLocationLayout_cityBackMunich.call(cityBack[2] as ISelectLocationLayout_cityBackMunich);
		cityBack[2].x = 0;
		cityBack[2].y = 0;
		if (cityBack[2].onLayout) cityBack[2].onLayout();
	}
	if (!cityBack[3] && cityBack.elementFactory) {
		cityBack[3] = cityBack.elementFactory(3,undefined);
	}
	if (cityBack[3]) {
		SelectLocationLayout_cityBackBeijing.call(cityBack[3] as ISelectLocationLayout_cityBackBeijing);
		cityBack[3].x = 0;
		cityBack[3].y = 0;
		if (cityBack[3].onLayout) cityBack[3].onLayout();
	}
	if (!cityBack[4] && cityBack.elementFactory) {
		cityBack[4] = cityBack.elementFactory(4,undefined);
	}
	if (cityBack[4]) {
		SelectLocationLayout_cityBackCusco.call(cityBack[4] as ISelectLocationLayout_cityBackCusco);
		cityBack[4].x = 0;
		cityBack[4].y = 0;
		if (cityBack[4].onLayout) cityBack[4].onLayout();
	}
	if (!cityBack[5] && cityBack.elementFactory) {
		cityBack[5] = cityBack.elementFactory(5,undefined);
	}
	if (cityBack[5]) {
		SelectLocationLayout_cityBackTokyo.call(cityBack[5] as ISelectLocationLayout_cityBackTokyo);
		cityBack[5].x = 0;
		cityBack[5].y = 0;
		if (cityBack[5].onLayout) cityBack[5].onLayout();
	}
	const cityFront = this.cityFront;
	if (!cityFront[0] && cityFront.elementFactory) {
		cityFront[0] = cityFront.elementFactory(0,undefined);
	}
	if (cityFront[0]) {
		SelectLocationLayout_cityFrontRio.call(cityFront[0] as ISelectLocationLayout_cityFrontRio);
		cityFront[0].x = 0;
		cityFront[0].y = 0;
		if (cityFront[0].onLayout) cityFront[0].onLayout();
	}
	if (!cityFront[1] && cityFront.elementFactory) {
		cityFront[1] = cityFront.elementFactory(1,undefined);
	}
	if (cityFront[1]) {
		SelectLocationLayout_cityFrontNairobi.call(cityFront[1] as ISelectLocationLayout_cityFrontNairobi);
		cityFront[1].x = 0;
		cityFront[1].y = 0;
		if (cityFront[1].onLayout) cityFront[1].onLayout();
	}
	if (!cityFront[2] && cityFront.elementFactory) {
		cityFront[2] = cityFront.elementFactory(2,undefined);
	}
	if (cityFront[2]) {
		SelectLocationLayout_cityFrontMunich.call(cityFront[2] as ISelectLocationLayout_cityFrontMunich);
		cityFront[2].x = 0;
		cityFront[2].y = 0;
		if (cityFront[2].onLayout) cityFront[2].onLayout();
	}
	if (!cityFront[3] && cityFront.elementFactory) {
		cityFront[3] = cityFront.elementFactory(3,undefined);
	}
	if (cityFront[3]) {
		SelectLocationLayout_cityFrontBeijing.call(cityFront[3] as ISelectLocationLayout_cityFrontBeijing);
		cityFront[3].x = 0;
		cityFront[3].y = 0;
		if (cityFront[3].onLayout) cityFront[3].onLayout();
	}
	if (!cityFront[4] && cityFront.elementFactory) {
		cityFront[4] = cityFront.elementFactory(4,undefined);
	}
	if (cityFront[4]) {
		SelectLocationLayout_cityFrontCusco.call(cityFront[4] as ISelectLocationLayout_cityFrontCusco);
		cityFront[4].x = 0;
		cityFront[4].y = 0;
		if (cityFront[4].onLayout) cityFront[4].onLayout();
	}
	if (!cityFront[5] && cityFront.elementFactory) {
		cityFront[5] = cityFront.elementFactory(5,undefined);
	}
	if (cityFront[5]) {
		SelectLocationLayout_cityFrontTokyo.call(cityFront[5] as ISelectLocationLayout_cityFrontTokyo);
		cityFront[5].x = 0;
		cityFront[5].y = 0;
		if (cityFront[5].onLayout) cityFront[5].onLayout();
	}
	const globeBg = this.globeBg;
	SelectLocationLayout_globeBg.call(this.globeBg);
	globeBg.x = 0;
	globeBg.y = 0;
	globeBg.width = 1923.00;
	globeBg.height = 1950.00;
	if (globeBg.onLayout) globeBg.onLayout();
	return this;
}
function SelectLocationLayout_cityBackRio(this: ISelectLocationLayout_cityBackRio) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_cityRio1.call(items[0] as ISelectLocationLayout_cityRio1);
		items[0].x = 449.95;
		items[0].y = -915.05;
		items[0].rotation = 0.5480;
		items[0].width = 715.97;
		items[0].height = 326.99;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_cityRio2.call(items[1] as ISelectLocationLayout_cityRio2);
		items[1].x = -345.75;
		items[1].y = -1072.5;
		items[1].rotation = -0.3121;
		items[1].width = 244.99;
		items[1].height = 634.98;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_cityRio3.call(items[2] as ISelectLocationLayout_cityRio3);
		items[2].x = -608.4;
		items[2].y = -1024.95;
		items[2].width = 188.00;
		items[2].height = 181.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityRio4.call(items[3] as ISelectLocationLayout_cityRio4);
		items[3].x = -538.5;
		items[3].y = -869.7;
		items[3].rotation = -0.5268;
		items[3].width = 484.00;
		items[3].height = 299.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		SelectLocationLayout_cityRio5.call(items[4] as ISelectLocationLayout_cityRio5);
		items[4].x = 459.6;
		items[4].y = -949.5;
		items[4].rotation = 0.3114;
		items[4].width = 209.00;
		items[4].height = 694.99;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		SelectLocationLayout_cityRio10.call(items[5] as ISelectLocationLayout_cityRio10);
		items[5].x = 386.2;
		items[5].y = -1068.7;
		items[5].width = 401.00;
		items[5].height = 454.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		SelectLocationLayout_cityRio9.call(items[6] as ISelectLocationLayout_cityRio9);
		items[6].x = -150.3;
		items[6].y = -1146.95;
		items[6].width = 243.00;
		items[6].height = 271.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityRio1(this: ISelectLocationLayout_cityRio1) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-1.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio2(this: ISelectLocationLayout_cityRio2) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-2.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio3(this: ISelectLocationLayout_cityRio3) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-3.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio4(this: ISelectLocationLayout_cityRio4) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-4.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio5(this: ISelectLocationLayout_cityRio5) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-5.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio10(this: ISelectLocationLayout_cityRio10) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-10.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio9(this: ISelectLocationLayout_cityRio9) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-9.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBackNairobi(this: ISelectLocationLayout_cityBackNairobi) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_cityNairobi4.call(items[0] as ISelectLocationLayout_cityNairobi4);
		items[0].x = 22.5;
		items[0].y = -1181.85;
		items[0].width = 727.00;
		items[0].height = 251.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_cityNairobi2.call(items[1] as ISelectLocationLayout_cityNairobi2);
		items[1].x = -521.25;
		items[1].y = -1137.45;
		items[1].rotation = -0.5787;
		items[1].width = 241.99;
		items[1].height = 105.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_cityNairobi3.call(items[2] as ISelectLocationLayout_cityNairobi3);
		items[2].x = -400.7;
		items[2].y = -928.7;
		items[2].rotation = -0.5312;
		items[2].width = 577.99;
		items[2].height = 285.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityNairobi1.call(items[3] as ISelectLocationLayout_cityNairobi1);
		items[3].x = 354.75;
		items[3].y = -987.6;
		items[3].rotation = 0.3626;
		items[3].width = 711.00;
		items[3].height = 366.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		SelectLocationLayout_cityNairobi8.call(items[4] as ISelectLocationLayout_cityNairobi8);
		items[4].x = 497.15;
		items[4].y = -998.65;
		items[4].rotation = 0.3057;
		items[4].width = 204.99;
		items[4].height = 572.98;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityNairobi4(this: ISelectLocationLayout_cityNairobi4) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-nairobi-4.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityNairobi2(this: ISelectLocationLayout_cityNairobi2) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-nairobi-2.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityNairobi3(this: ISelectLocationLayout_cityNairobi3) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-nairobi-3.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityNairobi1(this: ISelectLocationLayout_cityNairobi1) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-nairobi-1.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityNairobi8(this: ISelectLocationLayout_cityNairobi8) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-nairobi-8.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBackMunich(this: ISelectLocationLayout_cityBackMunich) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_cityMunich1.call(items[0] as ISelectLocationLayout_cityMunich1);
		items[0].x = -28.1;
		items[0].y = -986.2;
		items[0].width = 1303.00;
		items[0].height = 659.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityMunich1(this: ISelectLocationLayout_cityMunich1) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-munich-1.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBackBeijing(this: ISelectLocationLayout_cityBackBeijing) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_cityBeijing4.call(items[0] as ISelectLocationLayout_cityBeijing4);
		items[0].x = -667;
		items[0].y = -830.95;
		items[0].width = 251.00;
		items[0].height = 222.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_cityBeijing2.call(items[1] as ISelectLocationLayout_cityBeijing2);
		items[1].x = 12;
		items[1].y = -1175.7;
		items[1].rotation = 0.0793;
		items[1].width = 819.97;
		items[1].height = 452.99;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_cityBeijing3.call(items[2] as ISelectLocationLayout_cityBeijing3);
		items[2].x = -486.95;
		items[2].y = -1035.8;
		items[2].rotation = -0.4549;
		items[2].width = 567.99;
		items[2].height = 461.99;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityBeijing1.call(items[3] as ISelectLocationLayout_cityBeijing1);
		items[3].x = 492.05;
		items[3].y = -957.45;
		items[3].rotation = 0.6640;
		items[3].width = 737.99;
		items[3].height = 375.99;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		SelectLocationLayout_cityBeijing7.call(items[4] as ISelectLocationLayout_cityBeijing7);
		items[4].x = 499.55;
		items[4].y = -1058.7;
		items[4].rotation = 0.3403;
		items[4].width = 223.99;
		items[4].height = 653.98;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityBeijing4(this: ISelectLocationLayout_cityBeijing4) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-beijing-4.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBeijing2(this: ISelectLocationLayout_cityBeijing2) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-beijing-2.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBeijing3(this: ISelectLocationLayout_cityBeijing3) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-beijing-3.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBeijing1(this: ISelectLocationLayout_cityBeijing1) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-beijing-1.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBeijing7(this: ISelectLocationLayout_cityBeijing7) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-beijing-7.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBackCusco(this: ISelectLocationLayout_cityBackCusco) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_cityCusco1.call(items[0] as ISelectLocationLayout_cityCusco1);
		items[0].x = -32.9;
		items[0].y = -1040.55;
		items[0].width = 1187.00;
		items[0].height = 668.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_cityCusco2.call(items[1] as ISelectLocationLayout_cityCusco2);
		items[1].x = 495.6;
		items[1].y = -1041.95;
		items[1].rotation = 0.3489;
		items[1].width = 214.00;
		items[1].height = 448.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityCusco1(this: ISelectLocationLayout_cityCusco1) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-cusco-1.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityCusco2(this: ISelectLocationLayout_cityCusco2) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-cusco-2.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBackTokyo(this: ISelectLocationLayout_cityBackTokyo) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_cityTokyo2.call(items[0] as ISelectLocationLayout_cityTokyo2);
		items[0].x = -317.55;
		items[0].y = -1068.85;
		items[0].rotation = -0.3846;
		items[0].width = 1170.98;
		items[0].height = 507.99;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_cityTokyo1.call(items[1] as ISelectLocationLayout_cityTokyo1);
		items[1].x = 452.8;
		items[1].y = -1022.55;
		items[1].width = 699.00;
		items[1].height = 782.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityTokyo2(this: ISelectLocationLayout_cityTokyo2) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-tokyo-2.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityTokyo1(this: ISelectLocationLayout_cityTokyo1) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-tokyo-1.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_globeBg(this: ISelectLocationLayout_globeBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("globe.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityFrontRio(this: ISelectLocationLayout_cityFrontRio) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_circoGround.call(items[0] as ISelectLocationLayout_circoGround);
		items[0].x = -18.3;
		items[0].y = -792.9;
		items[0].width = 1117.00;
		items[0].height = 430.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_cityRio8.call(items[1] as ISelectLocationLayout_cityRio8);
		items[1].x = -414.85;
		items[1].y = -995.1;
		items[1].rotation = -0.3521;
		items[1].width = 483.00;
		items[1].height = 363.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_circoTent.call(items[2] as ISelectLocationLayout_circoTent);
		items[2].x = -30.15;
		items[2].y = -1041.2;
		items[2].width = 881.00;
		items[2].height = 545.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityRio7.call(items[3] as ISelectLocationLayout_cityRio7);
		items[3].x = 64.45;
		items[3].y = -1198.1;
		items[3].width = 164.00;
		items[3].height = 198.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		SelectLocationLayout_cityRio6.call(items[4] as ISelectLocationLayout_cityRio6);
		items[4].x = 343.05;
		items[4].y = -856;
		items[4].width = 154.00;
		items[4].height = 177.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function SelectLocationLayout_circoGround(this: ISelectLocationLayout_circoGround) {
	if (this.setLayoutTexture) this.setLayoutTexture("circo-ground.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio8(this: ISelectLocationLayout_cityRio8) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-8.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_circoTent(this: ISelectLocationLayout_circoTent) {
	if (this.setLayoutTexture) this.setLayoutTexture("circo-tent.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio7(this: ISelectLocationLayout_cityRio7) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-7.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityRio6(this: ISelectLocationLayout_cityRio6) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-rio-6.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityFrontNairobi(this: ISelectLocationLayout_cityFrontNairobi) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_circoGround.call(items[0] as ISelectLocationLayout_circoGround);
		items[0].x = -18.3;
		items[0].y = -792.9;
		items[0].width = 1117.00;
		items[0].height = 430.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_cityNairobi6.call(items[1] as ISelectLocationLayout_cityNairobi6);
		items[1].x = -440.75;
		items[1].y = -865.25;
		items[1].width = 229.00;
		items[1].height = 208.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_circoTent.call(items[2] as ISelectLocationLayout_circoTent);
		items[2].x = -30.15;
		items[2].y = -1041.2;
		items[2].width = 881.00;
		items[2].height = 545.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityNairobi5.call(items[3] as ISelectLocationLayout_cityNairobi5);
		items[3].x = 361.25;
		items[3].y = -872.75;
		items[3].width = 281.00;
		items[3].height = 193.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		SelectLocationLayout_cityNairobi7.call(items[4] as ISelectLocationLayout_cityNairobi7);
		items[4].x = -370.6;
		items[4].y = -799.8;
		items[4].width = 155.00;
		items[4].height = 136.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityNairobi6(this: ISelectLocationLayout_cityNairobi6) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-nairobi-6.png", 0.502, 0.500);
	return this;
}
function SelectLocationLayout_cityNairobi5(this: ISelectLocationLayout_cityNairobi5) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-nairobi-5.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityNairobi7(this: ISelectLocationLayout_cityNairobi7) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-nairobi-7.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityFrontMunich(this: ISelectLocationLayout_cityFrontMunich) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_circoGround.call(items[0] as ISelectLocationLayout_circoGround);
		items[0].x = -18.3;
		items[0].y = -792.9;
		items[0].width = 1117.00;
		items[0].height = 430.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_circoTent.call(items[1] as ISelectLocationLayout_circoTent);
		items[1].x = -30.15;
		items[1].y = -1041.2;
		items[1].width = 881.00;
		items[1].height = 545.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_cityMunich3.call(items[2] as ISelectLocationLayout_cityMunich3);
		items[2].x = 27.1;
		items[2].y = -1133.6;
		items[2].width = 108.00;
		items[2].height = 89.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityMunich2.call(items[3] as ISelectLocationLayout_cityMunich2);
		items[3].x = 349.6;
		items[3].y = -918.55;
		items[3].width = 229.00;
		items[3].height = 272.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		SelectLocationLayout_cityMunich4.call(items[4] as ISelectLocationLayout_cityMunich4);
		items[4].x = -470.65;
		items[4].y = -802.75;
		items[4].width = 423.00;
		items[4].height = 293.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityMunich3(this: ISelectLocationLayout_cityMunich3) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-munich-3.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityMunich2(this: ISelectLocationLayout_cityMunich2) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-munich-2.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityMunich4(this: ISelectLocationLayout_cityMunich4) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-munich-4.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityFrontBeijing(this: ISelectLocationLayout_cityFrontBeijing) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_circoGround.call(items[0] as ISelectLocationLayout_circoGround);
		items[0].x = -18.3;
		items[0].y = -792.9;
		items[0].width = 1117.00;
		items[0].height = 430.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_circoTent.call(items[1] as ISelectLocationLayout_circoTent);
		items[1].x = -30.15;
		items[1].y = -1041.2;
		items[1].width = 881.00;
		items[1].height = 545.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_cityBeijing6.call(items[2] as ISelectLocationLayout_cityBeijing6);
		items[2].x = -705.35;
		items[2].y = -785.95;
		items[2].width = 302.00;
		items[2].height = 219.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityBeijing5.call(items[3] as ISelectLocationLayout_cityBeijing5);
		items[3].x = 551.1;
		items[3].y = -902.35;
		items[3].width = 258.00;
		items[3].height = 207.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityBeijing6(this: ISelectLocationLayout_cityBeijing6) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-beijing-6.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityBeijing5(this: ISelectLocationLayout_cityBeijing5) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-beijing-5.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityFrontCusco(this: ISelectLocationLayout_cityFrontCusco) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_cityCusco3.call(items[0] as ISelectLocationLayout_cityCusco3);
		items[0].x = -449.55;
		items[0].y = -919.55;
		items[0].width = 156.00;
		items[0].height = 128.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_circoGround.call(items[1] as ISelectLocationLayout_circoGround);
		items[1].x = -18.3;
		items[1].y = -792.9;
		items[1].width = 1117.00;
		items[1].height = 430.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_circoTent.call(items[2] as ISelectLocationLayout_circoTent);
		items[2].x = -30.15;
		items[2].y = -1041.2;
		items[2].width = 881.00;
		items[2].height = 545.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityCusco4.call(items[3] as ISelectLocationLayout_cityCusco4);
		items[3].x = 283.7;
		items[3].y = -850.05;
		items[3].width = 117.00;
		items[3].height = 78.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		SelectLocationLayout_cityCusco5.call(items[4] as ISelectLocationLayout_cityCusco5);
		items[4].x = 360;
		items[4].y = -807.65;
		items[4].width = 124.00;
		items[4].height = 92.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		SelectLocationLayout_cityCusco4.call(items[5] as ISelectLocationLayout_cityCusco4);
		items[5].x = -402.6;
		items[5].y = -754.1;
		items[5].rotation = -0.5967;
		items[5].width = 117.00;
		items[5].height = 78.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityCusco3(this: ISelectLocationLayout_cityCusco3) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-cusco-3.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityCusco4(this: ISelectLocationLayout_cityCusco4) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-cusco-4.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityCusco5(this: ISelectLocationLayout_cityCusco5) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-cusco-5.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityFrontTokyo(this: ISelectLocationLayout_cityFrontTokyo) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		SelectLocationLayout_circoGround.call(items[0] as ISelectLocationLayout_circoGround);
		items[0].x = -18.3;
		items[0].y = -792.9;
		items[0].width = 1117.00;
		items[0].height = 430.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		SelectLocationLayout_cityTokyo5.call(items[1] as ISelectLocationLayout_cityTokyo5);
		items[1].x = -432;
		items[1].y = -873.2;
		items[1].rotation = -0.4092;
		items[1].width = 454.01;
		items[1].height = 153.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		SelectLocationLayout_circoTent.call(items[2] as ISelectLocationLayout_circoTent);
		items[2].x = -30.15;
		items[2].y = -1041.2;
		items[2].width = 881.00;
		items[2].height = 545.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		SelectLocationLayout_cityTokyo4.call(items[3] as ISelectLocationLayout_cityTokyo4);
		items[3].x = -643.9;
		items[3].y = -779.5;
		items[3].width = 188.00;
		items[3].height = 215.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		SelectLocationLayout_cityTokyo3.call(items[4] as ISelectLocationLayout_cityTokyo3);
		items[4].x = -455.9;
		items[4].y = -837.4;
		items[4].width = 198.00;
		items[4].height = 230.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function SelectLocationLayout_cityTokyo5(this: ISelectLocationLayout_cityTokyo5) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-tokyo-5.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityTokyo4(this: ISelectLocationLayout_cityTokyo4) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-tokyo-4.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_cityTokyo3(this: ISelectLocationLayout_cityTokyo3) {
	if (this.setLayoutTexture) this.setLayoutTexture("city-tokyo-3.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_buttonNext(this: ISelectLocationLayout_buttonNext) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-next.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_buttonBack(this: ISelectLocationLayout_buttonBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-back.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_frontClouds(this: ISelectLocationLayout_frontClouds) {
	if (this.setLayoutTexture) this.setLayoutTexture("front-clouds.png", 0.500, 1.000);
	return this;
}
function SelectLocationLayout_luna(this: ISelectLocationLayout_luna) {
	if (this.setLayoutTexture) this.setLayoutTexture("luna.png", 0.420, 1.000);
	return this;
}
function SelectLocationLayout_buttonFreePlay(this: ISelectLocationLayout_buttonFreePlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-free-play.png", 0.500, 0.500);
	return this;
}
function SelectLocationLayout_envelope(this: ISelectLocationLayout_envelope) {
	const envelopeClosed = this.envelopeClosed;
	SelectLocationLayout_envelopeClosed.call(this.envelopeClosed);
	envelopeClosed.x = 0;
	envelopeClosed.y = 179.5;
	envelopeClosed.width = 489.00;
	envelopeClosed.height = 359.00;
	if (envelopeClosed.onLayout) envelopeClosed.onLayout();
	const envelopeOpen = this.envelopeOpen;
	SelectLocationLayout_envelopeOpen.call(this.envelopeOpen);
	envelopeOpen.x = 0;
	envelopeOpen.y = 179.5;
	envelopeOpen.width = 491.00;
	envelopeOpen.height = 500.00;
	if (envelopeOpen.onLayout) envelopeOpen.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(12.80,-80.15,237.05,-164.00,861.55,-166.15,867.90,-1449.75,-822.55,-1439.80,-820.85,-169.85,-235.85,-161.05);
	const postcardBounds = this.postcardBounds;
	SelectLocationLayout_postcardBounds.call(this.postcardBounds);
	postcardBounds.x = -237.1;
	postcardBounds.y = -170.1;
	postcardBounds.width = 475.45;
	postcardBounds.height = 347.00;
	if (postcardBounds.onLayout) postcardBounds.onLayout();
	return this;
}
function SelectLocationLayout_envelopeClosed(this: ISelectLocationLayout_envelopeClosed) {
	if (this.setLayoutTexture) this.setLayoutTexture("envelope-beijing-closed.png", 0.500, 1.000);
	return this;
}
function SelectLocationLayout_envelopeOpen(this: ISelectLocationLayout_envelopeOpen) {
	if (this.setLayoutTexture) this.setLayoutTexture("envelope-beijing-open.png", 0.500, 1.000);
	return this;
}
function SelectLocationLayout_postcardMask(this: ISelectLocationLayout_postcardMask) {
	return this;
}
function SelectLocationLayout_postcardBounds(this: ISelectLocationLayout_postcardBounds) {
	return this;
}
function SelectLocationLayout_envelopeSelected(this: ISelectLocationLayout_envelopeSelected) {
	const envelopeClosed = this.envelopeClosed;
	SelectLocationLayout_envelopeClosed.call(this.envelopeClosed);
	envelopeClosed.x = 0;
	envelopeClosed.y = 179.5;
	envelopeClosed.width = 489.00;
	envelopeClosed.height = 359.00;
	if (envelopeClosed.onLayout) envelopeClosed.onLayout();
	return this;
}
interface ISelectLocationLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ISelectLocationLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ISelectLocationLayoutSprite extends ISelectLocationLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ISelectLocationLayoutText extends ISelectLocationLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ISelectLocationLayoutPolygon extends Array<number> {
}
interface ISelectLocationLayout {
	readonly main: ISelectLocationLayout_main;
}
interface ISelectLocationLayout_main extends ISelectLocationLayoutContainer {
	readonly globe: ISelectLocationLayout_globe;
	readonly buttonNext: ISelectLocationLayout_buttonNext;
	readonly buttonBack: ISelectLocationLayout_buttonBack;
	readonly frontClouds: ISelectLocationLayout_frontClouds;
	readonly luna: ISelectLocationLayout_luna;
	readonly buttonFreePlay: ISelectLocationLayout_buttonFreePlay;
	readonly envelope: ISelectLocationLayout_envelope;
	readonly envelopeSelected: ISelectLocationLayout_envelopeSelected;
}
interface ISelectLocationLayout_globe extends ISelectLocationLayoutContainer {
	readonly cityBack: ISelectLocationLayoutArray<ISelectLocationLayout_cityBackRio|ISelectLocationLayout_cityBackNairobi|ISelectLocationLayout_cityBackMunich|ISelectLocationLayout_cityBackBeijing|ISelectLocationLayout_cityBackCusco|ISelectLocationLayout_cityBackTokyo>;
	readonly cityFront: ISelectLocationLayoutArray<ISelectLocationLayout_cityFrontRio|ISelectLocationLayout_cityFrontNairobi|ISelectLocationLayout_cityFrontMunich|ISelectLocationLayout_cityFrontBeijing|ISelectLocationLayout_cityFrontCusco|ISelectLocationLayout_cityFrontTokyo>;
	readonly globeBg: ISelectLocationLayout_globeBg;
}
interface ISelectLocationLayout_cityBackRio extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_cityRio1|ISelectLocationLayout_cityRio2|ISelectLocationLayout_cityRio3|ISelectLocationLayout_cityRio4|ISelectLocationLayout_cityRio5|ISelectLocationLayout_cityRio10|ISelectLocationLayout_cityRio9>;
}
interface ISelectLocationLayout_cityRio1 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio2 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio3 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio4 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio5 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio10 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio9 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBackNairobi extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_cityNairobi4|ISelectLocationLayout_cityNairobi2|ISelectLocationLayout_cityNairobi3|ISelectLocationLayout_cityNairobi1|ISelectLocationLayout_cityNairobi8>;
}
interface ISelectLocationLayout_cityNairobi4 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityNairobi2 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityNairobi3 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityNairobi1 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityNairobi8 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBackMunich extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_cityMunich1>;
}
interface ISelectLocationLayout_cityMunich1 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBackBeijing extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_cityBeijing4|ISelectLocationLayout_cityBeijing2|ISelectLocationLayout_cityBeijing3|ISelectLocationLayout_cityBeijing1|ISelectLocationLayout_cityBeijing7>;
}
interface ISelectLocationLayout_cityBeijing4 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBeijing2 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBeijing3 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBeijing1 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBeijing7 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBackCusco extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_cityCusco1|ISelectLocationLayout_cityCusco2>;
}
interface ISelectLocationLayout_cityCusco1 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityCusco2 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBackTokyo extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_cityTokyo2|ISelectLocationLayout_cityTokyo1>;
}
interface ISelectLocationLayout_cityTokyo2 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityTokyo1 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_globeBg extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityFrontRio extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_circoGround|ISelectLocationLayout_cityRio8|ISelectLocationLayout_circoTent|ISelectLocationLayout_cityRio7|ISelectLocationLayout_cityRio6>;
}
interface ISelectLocationLayout_circoGround extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio8 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_circoTent extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio7 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityRio6 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityFrontNairobi extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_circoGround|ISelectLocationLayout_cityNairobi6|ISelectLocationLayout_circoTent|ISelectLocationLayout_cityNairobi5|ISelectLocationLayout_cityNairobi7>;
}
interface ISelectLocationLayout_cityNairobi6 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityNairobi5 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityNairobi7 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityFrontMunich extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_circoGround|ISelectLocationLayout_circoTent|ISelectLocationLayout_cityMunich3|ISelectLocationLayout_cityMunich2|ISelectLocationLayout_cityMunich4>;
}
interface ISelectLocationLayout_cityMunich3 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityMunich2 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityMunich4 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityFrontBeijing extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_circoGround|ISelectLocationLayout_circoTent|ISelectLocationLayout_cityBeijing6|ISelectLocationLayout_cityBeijing5>;
}
interface ISelectLocationLayout_cityBeijing6 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityBeijing5 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityFrontCusco extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_cityCusco3|ISelectLocationLayout_circoGround|ISelectLocationLayout_circoTent|ISelectLocationLayout_cityCusco4|ISelectLocationLayout_cityCusco5>;
}
interface ISelectLocationLayout_cityCusco3 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityCusco4 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityCusco5 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityFrontTokyo extends ISelectLocationLayoutContainer {
	readonly items: ISelectLocationLayoutArray<ISelectLocationLayout_circoGround|ISelectLocationLayout_cityTokyo5|ISelectLocationLayout_circoTent|ISelectLocationLayout_cityTokyo4|ISelectLocationLayout_cityTokyo3>;
}
interface ISelectLocationLayout_cityTokyo5 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityTokyo4 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_cityTokyo3 extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_buttonNext extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_buttonBack extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_frontClouds extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_luna extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_buttonFreePlay extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_envelope extends ISelectLocationLayoutContainer {
	readonly envelopeClosed: ISelectLocationLayout_envelopeClosed;
	readonly envelopeOpen: ISelectLocationLayout_envelopeOpen;
	readonly postcardMask: ISelectLocationLayout_postcardMask;
	readonly postcardBounds: ISelectLocationLayout_postcardBounds;
}
interface ISelectLocationLayout_envelopeClosed extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_envelopeOpen extends ISelectLocationLayoutSprite {
}
interface ISelectLocationLayout_postcardMask extends ISelectLocationLayoutPolygon {
}
interface ISelectLocationLayout_postcardBounds extends ISelectLocationLayoutContainer {
}
interface ISelectLocationLayout_envelopeSelected extends ISelectLocationLayoutContainer {
	readonly envelopeClosed: ISelectLocationLayout_envelopeClosed;
}
